import RecommendPsychotherapists from './RecommendPsychotherapists.js';

export default RecommendPsychotherapists;
